import React from 'react';
import { cn } from 'utils/ui/classes';
export function Timeline({ className, children }) {
    return (React.createElement("ol", { class: cn('relative border-s border-gray-200 dark:border-gray-700', className) }, children));
}
export function TimelineEvent({ children }) {
    return React.createElement("li", { class: "mb-10 ms-4" }, children);
}
export function TimelineDot() {
    return (React.createElement("div", { class: "absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700" }));
}
export function TimelineTitle({ children }) {
    return (React.createElement("time", { class: "mb-1 text-sm font-medium leading-none text-gray-900" }, children));
}
